import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "smart-layout-button__icons" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartLayoutButton',
  props: {
  collapsable: { type: Boolean, default: false },
  horizontal: { type: Boolean, default: false },
  isCollapsed: { type: Boolean, default: false },
  resizable: { type: Boolean, default: false },
  reverseIcon: { type: Boolean, default: false },
},
  emits: ["button-click", "button-mousedown"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const showArrowUp = computed<boolean>(
  () =>
    (!props.reverseIcon && ((props.resizable && !props.isCollapsed) || (!props.resizable && !props.isCollapsed))) ||
    (props.reverseIcon && (props.resizable || (!props.resizable && props.isCollapsed))),
);
const showArrowDown = computed<boolean>(
  () =>
    (!props.reverseIcon && (props.resizable || (!props.resizable && props.isCollapsed))) ||
    (props.reverseIcon && ((props.resizable && !props.isCollapsed) || (!props.resizable && !props.isCollapsed))),
);

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['smart-layout-button', { 'smart-layout-button--resizable': __props.resizable, 'smart-layout-button--horizontal': __props.horizontal }])
  }, [
    _createElementVNode("div", {
      class: "smart-layout-button__actions",
      onMousedown: _cache[0] || (_cache[0] = ($event: any) => (__props.resizable && emit('button-mousedown'))),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('button-click')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (showArrowUp.value)
          ? (_openBlock(), _createBlock(_component_ot_icon, {
              key: 0,
              class: "smart-layout-button__icon",
              name: "arrow-up",
              "inherit-stroke": "inherit-stroke"
            }))
          : _createCommentVNode("", true),
        (showArrowDown.value)
          ? (_openBlock(), _createBlock(_component_ot_icon, {
              key: 1,
              class: "smart-layout-button__icon",
              name: "arrow-down",
              "inherit-stroke": "inherit-stroke"
            }))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 2))
}
}

})